import React from 'react'
import { questionDetailUrl } from '@/urls'
import { withLocalePrefix } from '@/util/localePath'
import Helmet from '@/components/helmet'
import ShareService from '@/services/share'
import { i18n } from '@/locale/i18n'
import './HelmetMarketImage.scss'

const hasWindow = typeof window !== 'undefined'

const getPlatform = () => {
  if (!hasWindow || !window.location) return 'development'
  return window.location.host === 'futuur.com' ? 'production' : 'development'
}

const S3_BUCKET_URL =
  hasWindow && getPlatform() === 'production'
    ? 'https://futuur-media-production.s3.amazonaws.com'
    : 'https://futuur-staging-media-nonprod.s3.amazonaws.com'
const SCREENSHOTS_PATH = 'question_screenshots'

const getMarketImageUrl = id => `${S3_BUCKET_URL}/${SCREENSHOTS_PATH}/${id}.png`

const getFutuurCoverUrl = () => `${import.meta.env.VITE_FUTUUR_STATIC_URL}/img/meta/futuur.com.png`

function stripHtml(html) {
  if (typeof html !== 'string') return ''
  return html.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
}

function getMetaDescription(question) {
  const raw = question?.description || question?.rules || ''
  if (raw && typeof raw === 'string') {
    const text = stripHtml(raw).slice(0, 160).trim()
    if (text) return text
  }
  if (question?.title) return question.title
  const categories = question?.category?.map(c => c.title) || []
  const subcategory = categories[categories.length - 1] || 'Market'
  return i18n('question_details.meta_tags.description', { subcategory })
}

const extractMarketInfoFromUrl = () => {
  if (!hasWindow || !window.location) return null
  const path = window.location.pathname
  const matches = path.match(/\/q\/(\d+)\/(.+)/)
  if (matches) {
    const [, id, slug] = matches
    const title = slug.split('-').join(' ')
    return { id, title, slug }
  }
  return null
}

const HelmetMarketImage = ({ market }) => {
  const renderHelmet = question => {
    if (!question) {
      const urlInfo = extractMarketInfoFromUrl()
      if (urlInfo) {
        const title = `${urlInfo.title} ${i18n('question_details.meta_tags.title_suffix')}`
        const url = hasWindow ? window.location.href : ''
        const images = getMarketImageUrl(urlInfo.id)
        const description = i18n('question_details.meta_tags.description', {
          subcategory: 'Market',
        })

        return <Helmet id="view-question-details" url={url} title={title} images={images} description={description} />
      }
      return null
    }

    const categories = (question.category || []).map(category => category.title)
    const title = `${question.title} - ${categories[categories.length - 1]} ${i18n(
      'question_details.meta_tags.title_suffix'
    )}`
    const url = ShareService.shareableUrl(
      withLocalePrefix(hasWindow ? window.location.pathname : '', questionDetailUrl(question))
    )
    const images = question.id ? getMarketImageUrl(question.id) : getFutuurCoverUrl()
    const description = getMetaDescription(question)

    return <Helmet id="view-question-details" url={url} title={title} images={images} description={description} />
  }

  return renderHelmet(market)
}

export default HelmetMarketImage
